import {
  ControlCategories,
  isAdminUser,
  useAccountQuery,
} from "@theprelude/core";
import {
  ControlCategoryIcon,
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownTrigger,
  ExceptionIcon,
  IconButton,
  MoreIcon,
} from "@theprelude/ds";
import { Node, NodeProps } from "@xyflow/react";
import { useOverlay } from "@/hooks/use-overlay";
import { usePopper } from "@/hooks/use-popper";
import { ControlCategoryDataPoint } from "@/queries/control-monitor";
import { AggregateNode } from "./aggregate-node";

export type ControlCategoryNodeType = Node<
  ControlCategoryDataPoint,
  ControlCategoryDataPoint["type"]
>;

export const ControlCategoryNode = ({
  data,
}: NodeProps<ControlCategoryNodeType>) => {
  const dropdown = usePopper();
  const overlay = useOverlay();
  const account = useAccountQuery();
  const isAdmin = isAdminUser(account.data) ?? false;

  return (
    <AggregateNode
      data={data}
      icon={<ControlCategoryIcon category={data.category} />}
      hasParent
      actionsDropdown={
        data.category !== ControlCategories.NETWORK && (
          <Dropdown {...dropdown}>
            <DropdownTrigger asChild>
              <IconButton
                icon={<MoreIcon className="group-[.expanded]:text-white" />}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              />
            </DropdownTrigger>
            <DropdownContent align="end">
              <DropdownItem
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onSelect={() =>
                  overlay.open("add-object-exception", {
                    category: data.category,
                  })
                }
                disabled={!isAdmin}
              >
                <div className="flex flex-nowrap items-center gap-1">
                  <ExceptionIcon />
                  <span>Add Exception</span>
                </div>
              </DropdownItem>
            </DropdownContent>
          </Dropdown>
        )
      }
    />
  );
};
